import { CommandBarButton, IIconProps, mergeStyleSets } from "@fluentui/react";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "../../../store/hooks";
import ConfigValueFieldsDialog from "./ConfigValueFieldsDialog";

const configIcon: IIconProps = { iconName: "NumberField" };

function ConfigureValueFields() {
  const { t } = useTranslation();

  const client = useSelector((s) => s.clients.client);
  const clientId = client?.clientId;

  const [showDialog, setShowDialog] = useState(false);

  const handleToggleShowDialog = useCallback(() => {
    setShowDialog((prev) => !prev);
  }, []);

  return (
    <>
      {showDialog && (
        <ConfigValueFieldsDialog
          showDialog={showDialog}
          toggleShowDialog={handleToggleShowDialog}
        />
      )}
      <CommandBarButton
        disabled={!clientId}
        onClick={handleToggleShowDialog}
        iconProps={configIcon}
        className={classes.buttonClass}
        text={t("rvm.configValueFields.label")}
      />
    </>
  );
}

export default ConfigureValueFields;

const classes = mergeStyleSets({
  buttonClass: {
    display: "flex",
    alignItems: "center",
    height: 32,
    ".ms-Button-icon": {
      height: "inherit",
      display: "flex",
      alignItems: "center",
    },
  },
});
